// Side-loading collapse functionality, developed for the navigation top mobile menu
var displayControlsAreLoaded = false;
var productFilterBarCloseButton = false;

const sideCollapseSelector = '.wf-side-collapse';
const sideCollapseOpenButtonSelector = '.wf-side-collapse-button-open';
const sideCollapseBackButtonSelector = '.wf-side-collapse-button-back';
const sideCollapseCloseButtonSelector = '.wf-side-collapse-button-close';

const sideCollapseActiveClassName = 'wf-side-collapse-active';
const sideCollapseClosingClassName = 'wf-side-collapse-closing';
const collapseClosingDelay = 500;

// Initializes the side collapse functionality
export function initialize() {
  const sideCollapses = document.querySelectorAll(sideCollapseSelector);
  const sideCollapseOpenButtons = document.querySelectorAll(sideCollapseOpenButtonSelector);
  const sideCollapseBackButtons = document.querySelectorAll(sideCollapseBackButtonSelector);
  const sideCollapseCloseButtons = document.querySelectorAll(sideCollapseCloseButtonSelector);

  // Open target side collapse on open button click
  sideCollapseOpenButtons.forEach(openButton => {
    openButton.addEventListener('click', event => {
      const targetCollapse = document.querySelector(openButton.dataset['wfCollapseTarget']);
      openSideCollapse(targetCollapse);
    });
  });

  // Close parent side collapses on back button click
  sideCollapseBackButtons.forEach(backButton => {
    backButton.addEventListener('click', event => {
      const parentCollapse = backButton.closest(sideCollapseSelector);
      closeSideCollapse(parentCollapse);
    });
  });

  // Close all side collapses on close button click
  sideCollapseCloseButtons.forEach(closeButton => {
    closeButton.addEventListener('click', event => {
      sideCollapses.forEach(item => {
        closeSideCollapse(item);
      });
    });
  });

  // Close all side collapses when escape key is pressed
  document.onkeydown = (event => {
    event = event || window.event;
    if (event.key === 'Escape') {
      sideCollapses.forEach(item => {
        closeSideCollapse(item);
      });
    }
  });
  document.addEventListener('productCategoryDetailLoaded', () => {
    if(!displayControlsAreLoaded) {
      initProductDisplayControlClick();
      initProductDisplayControlCloseBtn();
    }
  });
}

// Disable body scroll
function disableBodyScroll() {
  document.body.style.overflow = 'hidden';
}

// Enable body scroll
function enableBodyScroll() {
  document.body.style.overflow = '';
}

// Activates the specified side collapse
function openSideCollapse(item) {
  item.classList.add(sideCollapseActiveClassName);
  disableBodyScroll();
}

// Deactivates the specified side collapse
function closeSideCollapse(item) {
  if (item.classList.contains(sideCollapseActiveClassName)) {
    item.classList.remove(sideCollapseActiveClassName);
    item.classList.add(sideCollapseClosingClassName);
    enableBodyScroll();

    setTimeout(function() {
      item.classList.remove(sideCollapseClosingClassName);
    },
    collapseClosingDelay);
  }
}

function initProductDisplayControlClick(){
  let element = document.querySelector('.wf-product-display-controls ' + sideCollapseOpenButtonSelector);
  addOpenEventListener(element);
}

function initProductDisplayControlCloseBtn(){
  let element = document.querySelector('#filters-side-collapse .wf-side-collapse-button-close');
  addCloseEventListener(element);
}

function addOpenEventListener(element){
  if(!element) return;

  if(element.dataset['wfCollapseTarget'] === '#filters-side-collapse'){
    displayControlsAreLoaded = true;
  }

  element.addEventListener('click', event => {
    const targetCollapse = document.querySelector(element.dataset['wfCollapseTarget']);
    openSideCollapse(targetCollapse);
  });
}

function addCloseEventListener(element){
  if(!element) return;

  const sideCollapses = document.querySelectorAll(sideCollapseSelector);
  const sideBarClose =  document.querySelector('#filters-side-collapse .wf-side-collapse-button-close');
  if(sideCollapses === sideBarClose){
    productFilterBarCloseButton = true;
  }
  element.addEventListener('click', event => {
    sideCollapses.forEach(item => {
      closeSideCollapse(item);
    });
  });
}

initialize();
